export { default } from './exam-service';
export * from './exam-service';
